import React from 'react'

const HowWeWork = () => {
    return (
        <>
            <div className="how-we-work">
                <div className="container">
                    <div className="row section-row align-items-center">
                        <div className="col-lg-6">
                            {/* Section Title Start */}
                            <div className="section-title dark-section">
                                <h3 className="wow fadeInUp" style={{ fontSize: 25 }}>
                                    how we work
                                </h3>
                                <h2 className="text-anime-style-2" data-cursor="-opaque">
                                    From concept to completion in<span> our work</span>
                                </h2>
                            </div>
                            {/* Section Title End */}
                        </div>
                        <div className="col-lg-6">
                            {/* Section Title Content Start */}
                            <div className="section-title-content dark-section">
                                <p className="wow fadeInUp" data-wow-delay="0.2s">
                                    Our comprehensive approach guides you through each phase of the
                                    design process, from initial brainstorming and conceptualization.
                                </p>
                            </div>
                            {/* Section Title Content End */}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            {/* How We Work List Start */}
                            <div className="how-we-work-list">
                                {/* How We Item Start */}
                                <div className="how-we-work-item wow fadeInUp">
                                    <div className="icon-box">
                                        <img src="images/icon-how-we-work-1.svg" alt="" />
                                    </div>
                                    <div className="how-we-work-content">
                                        <h3>01. initial consultation</h3>
                                        <p>
                                            We start with a one-on meeting to understand your vision
                                            preferences and requirement.
                                        </p>
                                    </div>
                                </div>
                                {/* How We Item End */}
                                {/* How We Item Start */}
                                <div className="how-we-work-item wow fadeInUp" data-wow-delay="0.2s">
                                    <div className="icon-box">
                                        <img src="images/icon-how-we-work-2.svg" alt="" />
                                    </div>
                                    <div className="how-we-work-content">
                                        <h3>02. Planning</h3>
                                        <p>It is always useful to create a plan and budget for the entire project.</p>
                                    </div>
                                </div>
                                {/* How We Item End */}
                                {/* How We Item Start */}
                                <div className="how-we-work-item wow fadeInUp" data-wow-delay="0.4s">
                                    <div className="icon-box">
                                        <img src="images/icon-how-we-work-3.svg" alt="" />
                                    </div>
                                    <div className="how-we-work-content">
                                        <h3>03. Designing</h3>
                                        <p>This involves selecting materials and layouts, furnishings, as well as creating 2D drafting and 3D renders.</p>
                                    </div>
                                </div>
                                {/* How We Item End */}
                                {/* How We Item Start */}
                                <div className="how-we-work-item wow fadeInUp" data-wow-delay="0.6s">
                                    <div className="icon-box">
                                        <img src="images/icon-how-we-work-4.svg" alt="" />
                                    </div>
                                    <div className="how-we-work-content">
                                        <h3>04. final review</h3>
                                        <p>
                                            After completing project we conduct a thorough walkthrough with
                                            you to review the space.
                                        </p>
                                    </div>
                                </div>
                                {/* How We Item End */}
                            </div>
                            {/* How We Work List End */}
                        </div>
                    </div>
                </div>
                {/* How Work Company Slider End */}
            </div>

        </>
    )
}

export default HowWeWork
